import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DictionaryAssetDeliveryStatus,
  DictionaryContractType,
} from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { AssetInspectionModalComponent } from '../../asset-modals/asset-inspection-modal/asset-inspection-modal.component';
import { AssetDeliveryDelegateModalComponent } from '../../asset-modals/asset-delivery-delegate-modal/asset-delivery-delegate-modal.component';

@Component({
  selector: 'asset-list-view',
  templateUrl: './asset-list-view.component.html',
  styleUrls: ['./asset-list-view.component.scss'],
  standalone: false,
})
export class AssetListViewComponent {
  public constructor(
    private _router: Router,
    private _ngbModal: NgbModal
  ) {}

  @Input() public orderedAssets: app.models.AssetListModel[] = [];
  @Input() public allAssets: app.models.AssetListModel[] = [];
  @Input() public requestAccessWarnings: string[] = [];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public navigateToDetailHandler: any;
  @Input() public activeContracts: boolean = true;

  ContractType = DictionaryContractType;
  AssetDeliveryStatus = DictionaryAssetDeliveryStatus;

  redirectDocumentRequest(event: Event, contractId: string, assetId: string) {
    event.stopPropagation();
    this._router.navigate(['requests/new', contractId, assetId]);
  }

  navigateToContractHandler(event: Event, contractId: string) {
    event.stopPropagation();
    this._router.navigate(['contracts', contractId]);
  }

  openAssetInspectionModal(event: Event) {
    event.stopPropagation();
    this._ngbModal.open(AssetInspectionModalComponent, {
      centered: true,
      scrollable: true,
    });
  }

  openDelegateModal(event: Event, asset: app.models.AssetListModel) {
    event.stopPropagation();
    const modalRef = this._ngbModal.open(AssetDeliveryDelegateModalComponent, {
      scrollable: true,
    });
    modalRef.componentInstance.asset = asset;
  }
}
